<div class="card" style="margin-bottom: 0px; margin-top: 0px;font-family: Avenir,Avenir Next,Segoe UI,Helvetica,Arial,sans-serif;">

    <div class="card-header card-header-primary">
        <div class="row">
           
            <div class="col-sm-12 col-md-11">
              <h4 class="card-title">Historial de asignaciones</h4>
            </div>
            <div class="col-sm-12 col-md-1">
                <button mat-icon-button (click)="onCloseClick()">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <div class="card-body">
        <div class="wraper">
            <div class="container">

                <div class="card-body"  style="height:450px; overflow: scroll;">
                    <div class="card"  >
                        <div class="card-header card-header-warning"></div>
                            <div class="card-body">
                                <div class="row">   
                                    <div class="col-md-6">
                                            <div class="row">
                                              <div class="col-auto mr-auto">
                                                <span><i class="fa fa fa-calendar fa-lg text-danger"></i>
                                                    <strong> Fecha: </strong> 
                                                </span>
                                              </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-auto mr-auto">
                                                    <span>
                                                        <i class="fa fa fa-user-circle-o fa-lg text-success"></i>
                                                        <strong> Asignado anterior:</strong>  
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="row ">
                                                <div class="col-auto mr-auto">
                                                    <span><i class="fa fa fa-user-circle-o fa-lg text-success"></i>
                                                        <strong> Asignado actual: </strong> 
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="row ">
                                                <div class="col-auto mr-auto">
                                                    <span>
                                                        <i class="fa fa fa-user-circle-o fa-lg text-success"></i>
                                                        <strong> Asignó: </strong>     </span>
                                                </div>
                                            </div>
                                        
                                    </div>
                                    <div class="col-md-6">
                                      <mat-form-field appearance="outline">
                                        <mat-label><b> Motivo </b></mat-label>
                                        <textarea  maxlength="2000" class="border" matInput aria-label="Motivo"
                                                   cols="50" style="background: #cecece45">
                                        </textarea>
                                      </mat-form-field>
                                    </div>
                                                  </div>
                                          </div>

                         
                    </div>
              </div>

            </div>
        </div>
    </div>
</div>